import { types } from '@sunwisesoftware/sunwise-template-core';
import i18next from 'i18next';

import { getPdfFile } from 'common/api/sunpal/renderTemplate';
import { downloadFile } from 'common/utils/helpers';
import showToast from 'common/utils/showToast';

export default (
        templateFinishedId,
        renderName,
        openLoading,
        closeLoading,
        templateType = types.ONE_PROPOSAL_TYPE,
    ) =>
    () => {
        openLoading(i18next.t('Downloading'));

        return getPdfFile({
            quality: '2',
            renderName,
            templateFinishedId,
            templateType,
        })
            .then((response) => {
                closeLoading();

                downloadFile(response.data, `${renderName}.pdf`);

                showToast({
                    body: i18next.t('It has been downloaded successfully'),
                });
            })
            .catch(() => {
                closeLoading();
                showToast({
                    body: i18next.t('An error has occurred'),
                    type: 'danger',
                });
            });
    };
